import {useState} from "react";

export function useIsProduction() {
    const [isProduction, setIsProduction] = useState<boolean>((window as any).IS_PROD || false);

    return isProduction;
}
